import { Component, ErrorInfo, ReactNode } from 'react'
import ErrorCard from 'src/components/error/ErrorCard'

interface Props {
  children: ReactNode
  fallbackComponent?: ReactNode
  message?: string
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallbackComponent || (
          <ErrorCard message={this.props?.message} />
        )
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
